import { set } from '@/utils/vuex'
import { getConfig } from '@/api/user'

const state = {
  loading: false,
  drawer: null,
  color: 'success',
  image: '',
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.84)',
  snackbar: {},

  s3BaseUrl: '',
  siteUrl: '',

  announcement: '',
  maintainance: '',
  changePass: {}
}

const mutations = {
  loading: set('loading'),
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  snackbar: set('snackbar'),

  s3BaseUrl: set('s3BaseUrl'),
  siteUrl: set('siteUrl'),

  SET_ANNOUNCEMENT: (state, announcement) => {
    state.announcement = announcement
  },
  SET_MAINTAINANCE: (state, maintainance) => {
    state.maintainance = maintainance
  },

  changePass: set('changePass')
}

const actions = {
  startLoading: (context) => {
    context.commit('loading', true)
  },
  stopLoading: (context) => {
    context.commit('loading', false)
  },
  openSnackbar: (context, payload) => {
    payload['active'] = true
    context.commit('snackbar', payload)
  },
  closeSnackbar: context => {
    context.commit('snackbar', {active: false})
  },

  async getConfig({ commit }) {
    const ret = await getConfig()
    commit('SET_ANNOUNCEMENT', ret.announcement)
    commit('SET_MAINTAINANCE', ret.maintainance)
    commit('s3BaseUrl', ret.s3BaseUrl)
    commit('siteUrl', ret.siteUrl)
  },

  openChangePassword: (context, payload) => {
    payload['active'] = true
    context.commit('changePass', payload)
  },
  closeChangePassword: context => {
    context.commit('changePass', {active: false})
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
